import Config from "./Config.container.screen";

export default Config;
